// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-toast {
  min-width: 320px;
  max-width: 500px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 9px 25px 0px rgba(129, 155, 163, 0.27);
  border: none;
  margin-bottom: 12px;
}
.custom-toast .toast-body {
  padding: 0;
}
.custom-toast .toast-content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
}
.custom-toast .toast-content .toast-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.custom-toast .toast-content .toast-message {
  flex: 1 1;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.5;
  color: #142a31;
}
.custom-toast .toast-content .toast-close {
  flex-shrink: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #88abb4;
  transition: color 0.2s;
}
.custom-toast .toast-content .toast-close:hover {
  color: #142a31;
}
.custom-toast.toast-success {
  border-left: 4px solid #10b981;
}
.custom-toast.toast-error {
  border-left: 4px solid #ef4444;
}
.custom-toast.toast-warning {
  border-left: 4px solid #f59e0b;
}
.custom-toast.toast-info {
  border-left: 4px solid #3b82f6;
}`, "",{"version":3,"sources":["webpack://./src/components/Toast/toast.scss"],"names":[],"mappings":"AACA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sDAAA;EACA,YAAA;EACA,mBAAA;AAAF;AAEE;EACE,UAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AADJ;AAGI;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADN;AAII;EACE,SAAA;EACA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAFN;AAKI;EACE,cAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;AAHN;AAKM;EACE,cAAA;AAHR;AASE;EACE,8BAAA;AAPJ;AAUE;EACE,8BAAA;AARJ;AAWE;EACE,8BAAA;AATJ;AAYE;EACE,8BAAA;AAVJ","sourcesContent":["// Custom styles for React Bootstrap Toast\n.custom-toast {\n  min-width: 320px;\n  max-width: 500px;\n  background: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0px 9px 25px 0px rgba(129, 155, 163, 0.27);\n  border: none;\n  margin-bottom: 12px;\n\n  .toast-body {\n    padding: 0;\n  }\n\n  .toast-content {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px 20px;\n\n    .toast-icon {\n      flex-shrink: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .toast-message {\n      flex: 1;\n      font-family: \"Inter\", sans-serif;\n      font-weight: 500;\n      font-size: 14px;\n      line-height: 1.5;\n      color: #142a31;\n    }\n\n    .toast-close {\n      flex-shrink: 0;\n      background: transparent;\n      border: none;\n      cursor: pointer;\n      padding: 4px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #88abb4;\n      transition: color 0.2s;\n\n      &:hover {\n        color: #142a31;\n      }\n    }\n  }\n\n  // Border color based on type\n  &.toast-success {\n    border-left: 4px solid #10b981;\n  }\n\n  &.toast-error {\n    border-left: 4px solid #ef4444;\n  }\n\n  &.toast-warning {\n    border-left: 4px solid #f59e0b;\n  }\n\n  &.toast-info {\n    border-left: 4px solid #3b82f6;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
